import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buttonStyles } from '@/styles/buttons';
import { cardStyles } from '@/styles/cards';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '2rem',
        backgroundColor: 'var(--background-alt)',
      }}
    >
      <div
        style={{
          ...cardStyles.default,
          textAlign: 'center',
          maxWidth: '400px',
        }}
      >
        <h1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            color: 'var(--primary-color)',
            margin: '0 0 0.5rem 0',
          }}
        >
          404
        </h1>
        <h2
          style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: 'var(--text-primary)',
            margin: '0 0 1rem 0',
          }}
        >
          {t('notFound.title')}
        </h2>
        <p
          style={{
            color: 'var(--text-secondary)',
            marginBottom: '1.5rem',
          }}
        >
          {t('notFound.description')}
        </p>
        <button onClick={() => navigate('/')} style={buttonStyles.primary}>
          {t('notFound.goHome')}
        </button>
      </div>
    </div>
  );
}
